"use strict";
Object.defineProperty(globalThis, 'scene', {
    get: () => window.mainScene,
    configurable: true,
    enumerable: true,
});
Object.defineProperty(globalThis, 'animationManager', {
    get: () => window.AnimationManager,
    configurable: true,
    enumerable: true,
});
Object.defineProperty(globalThis, 'soundManager', {
    get: () => window.SoundManager,
    configurable: true,
    enumerable: true,
});
Object.defineProperty(globalThis, 'generalManager', {
    get: () => window.GeneralManager,
    configurable: true,
    enumerable: true,
});
Object.defineProperty(globalThis, 'gameLogicVariableManager', {
    get: () => window.GameLogicVariableManager,
    configurable: true,
    enumerable: true,
});
Object.defineProperty(globalThis, 'gameDataManager', {
    get: () => window.GameDataManager,
    configurable: true,
    enumerable: true,
});
Object.defineProperty(globalThis, 'globalVariableManager', {
    get: () => window.GlobalVariableManager,
    configurable: true,
    enumerable: true,
});
Object.defineProperty(globalThis, 'layoutBuilder', {
    get: () => window.LayoutBuilder,
    configurable: true,
    enumerable: true,
});
Object.defineProperty(globalThis, 'phaserGame', {
    get: () => window.__PHASER_GAME__,
    configurable: true,
    enumerable: true,
});
